import { BASE_URL } from 'config';
import React, { useState, useEffect } from "react";
import {
  Box,
  TextField,
  Select,
  MenuItem,
  Button,
  Avatar,
  Typography,
  FormControl,
  FormHelperText,
  InputLabel,
  Grid,
  Divider,
  Input,
  IconButton,
  Autocomplete,
} from "@mui/material";
import inputLabel from "assets/theme/components/form/inputLabel";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import { validateEmail, validateRequired, validatePasswordMatch } from "validations";
import axios from "axios";
import Swal from "sweetalert2";
import avatar from "assets/theme/components/avatar";
import { useMaterialUIController } from 'context';
import { useTheme } from "@mui/material/styles";
const AddCategoryForm = ({ onClose, onSuccess, initialData }) => {

  const [controller] = useMaterialUIController();
  const darkMode = controller.darkMode;
  const theme = useTheme();



  const [categories, setCategories] = useState([]);
  useEffect(() => {
    const fetchCategories = async () => {
      const token = localStorage.getItem("user-token");
      try {
        const response = await fetch(
          BASE_URL + "/administrator/categories",
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const data = await response.json();
        setCategories(data.data);
      } catch (error) {
      }
    };

    fetchCategories();
  }, []);
  const [formData, setFormData] = useState({
    name: initialData?.name || "",
    keywords: initialData?.keywords || "",
    slug: initialData?.slug || "",
    meta_title: initialData?.meta_title || "",
    meta_icon: initialData?.meta_icon || null,
    image: initialData?.image || null,
    banner: initialData?.banner || null,
    description: initialData?.description || "",
    id: initialData?.id || null, // Add ID field
    parent_id: initialData?.parent_id || "",
  });

  // Add useEffect to handle initial data
  useEffect(() => {
    if (initialData && categories.length > 0) {
      setFormData({
        name: initialData.name,
        keywords: initialData.keywords,
        slug: initialData.slug,
        meta_title: initialData.meta_title,
        meta_icon: initialData.meta_icon,
        image: initialData.image,
        banner: initialData.banner,
        description: initialData?.description || "",
        id: initialData.id, // Add ID field
        parent_id: initialData.parent_id,
      });
    }
  }, [initialData]);
  const [errors, setErrors] = useState({});
  const [formSubmitted, setFormSubmitted] = useState(false);

  useEffect(() => {
    if (formSubmitted) validateForm();
  }, [formData]);

  const validateForm = () => {
    const newErrors = {};

    if (!validateRequired(formData.name)) newErrors.name = "يجب إدخال الاسم";
    if (!formData.image) newErrors.image = "يجب اختيار صورة الفئة";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    const fieldName = e.target.name;

    const allowedTypes = ["image/png", "image/jpeg", "image/jpg", "image/gif"];

    // إذا لم يتم رفع ملف
    if (!file) {
      if (fieldName === "image") {
        setFormData((prev) => ({ ...prev, image: null }));
        setErrors((prev) => ({
          ...prev,
          image: "يجب اختيار صورة الفئة",
        }));
      }
      return;
    }

    // إذا كان نوع الملف غير مدعوم
    if (!allowedTypes.includes(file.type)) {
      setErrors((prev) => ({
        ...prev,
        [fieldName]: "يجب أن تكون الصورة بصيغة PNG أو JPG أو JPEG أو GIF فقط",
      }));
      setFormData((prev) => ({ ...prev, [fieldName]: null }));
      return;
    }

    // في حال كانت الصورة صالحة
    setFormData((prev) => ({ ...prev, [fieldName]: file }));
    setErrors((prev) => ({ ...prev, [fieldName]: "" }));
  };
  // creating new category or updating existing
  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormSubmitted(true);
    if (!validateForm()) return;
    try {
      const formPayload = new FormData();
      // Append all form data including files
      Object.entries(formData).forEach(([key, value]) => {
        if (value !== null && value !== undefined && key !== "id") {
          // Handle avatar differently for existing vs new
          if (key === "image" || key === "meta_icon" || key === "banner") {
            // Only append new files, keep existing path if no new file
            if (value instanceof File) {
              formPayload.append(key, value);
            }
          } else {
            formPayload.append(key, value);
          }
        }
      });
      // Show loading indicator
      Swal.fire({
        title: "جاري الحفظ...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
          const container = document.querySelector(".swal2-container");
          container.style.zIndex = "99999";
        },
      });
      const token = localStorage.getItem("user-token");
      const endpoint = formData.id
        ? `${BASE_URL}/administrator/categories/update/${formData.id}`
        : BASE_URL + "/administrator/categories/store";
      const response = await axios.post(endpoint, formPayload, {
        headers: {
          "Content-Type": "multipart/form-data",

          Authorization: `Bearer ${token}`,
        },
      });
      // Close loading indicator
      Swal.close();
      if (response.data.status) {
        await Swal.fire({
          icon: "success",
          title: "تم الحفظ!",
          text: "تم حفظ البيانات بنجاح",
          confirmButtonText: "موافق",
          didOpen: () => {
            const container = document.querySelector(".swal2-container");
            container.style.zIndex = "99999";
          },
        });
        onSuccess();
        onClose();
      } else {
        throw new Error(response.data.message || "حدث خطأ غير متوقع");
      }
    } catch (error) {
      Swal.close();
      const errorMessage = error.response?.data?.message || error.message || "حدث خطأ أثناء  الحفظ";
      Swal.fire({
        icon: "error",
        title: "فشل الحفظ!",
        text: errorMessage,
        confirmButtonText: "موافق",
        didOpen: () => {
          const container = document.querySelector(".swal2-container");
          container.style.zIndex = "99999";
        },
      });
    } finally {
      setFormSubmitted(false);
    }
  };

  const handleCancel = () => {
    setFormData({
      name: "",
      keywords: "",
      slug: "",
      meta_title: "",
      meta_icon: null,
      image: null,
      banner: null,
      description: "",
      parent_id: null,
    });
    setErrors({});
    onClose();
  };
  const handleRemoveImage = () => {
    setFormData((prev) => ({ ...prev, logo: null }));
  };
  return (
    <Box
      sx={{
        p: 3,
        width: "100%",
        bgcolor: darkMode ? theme.palette.background.default : "background.paper",
        borderRadius: 2,
        boxShadow: 3,
      }}
    >
      {/* Header */}
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <Typography variant="h5" fontWeight="bold">
          {formData.id ? "تعديل بيانات الفئة" : "إضافة فئة جديدة"}
        </Typography>
      </Box>

      {/* Main Form */}

      <Box container spacing={3}>

        <Box display="flex" justifyContent="center" alignItems="center" gap={2}>
          <FormControl fullWidth error={!!errors.name} sx={{ mb: 2 }}>
            <TextField
              label="اسم الفئة*"
              name="name"
              value={formData.name}
              onChange={handleChange}
              error={!!errors.name}
              helperText={errors.name}
            />
          </FormControl>
          <FormControl fullWidth sx={{ mb: 2 }}>
            <TextField
              label="كلمات تحسين محركات البحث"
              name="keywords"
              value={formData.keywords}
              onChange={handleChange}
            />
          </FormControl>
        </Box>
        <Box display="flex" justifyContent="center" alignItems="center" gap={2}>
          <FormControl fullWidth sx={{ mb: 2 }}>
            <TextField
              label="الاسم في رابط URL"
              name="slug"
              value={formData.slug}
              onChange={handleChange}
            />
          </FormControl>
          <FormControl fullWidth sx={{ mb: 2 }}>
            <TextField
              label="عنوان علامة التبويب"
              name="meta_title"
              value={formData.meta_title}
              onChange={handleChange}
            />
          </FormControl>
        </Box>
        <Box display="flex" justifyContent="center" alignItems="center" gap={2}>
          <FormControl fullWidth sx={{ mb: 2 }}>
            <Autocomplete
              options={categories}
              getOptionLabel={(option) => option?.name || ""}
              value={categories?.find((cat) => cat.id === formData.parent_id) || ""}
              onChange={(e, newValue) => {
                setFormData((prev) => ({ ...prev, parent_id: newValue ? newValue.id : "" }));
              }}
              renderInput={(params) => (
                <TextField {...params} label="الفئة الأب (اختياري)" variant="outlined" />
              )}
              isOptionEqualToValue={(option, value) => option.id === value?.id}
              clearOnEscape
            />
          </FormControl>
          <FormControl fullWidth sx={{ mb: 2 }}>
            <TextField
              label="الوصف"
              name="description"
              value={formData.description}
              onChange={handleChange}
            />
          </FormControl>
        </Box>
      </Box>
      <Box display="flex" justifyContent="space-between" alignItems="center" gap={2}>
        <Box mt={3}>
          <Typography variant="subtitle1" gutterBottom fontWeight="bold" color="text.main">
            صورة الفئة
          </Typography>
          <Input
            type="file"
            inputProps={{ accept: "image/png, image/jpeg, image/gif,image/jpg" }}
            onChange={handleImageChange}
            sx={{ display: "none" }}
            id="image-upload"
            name="image"
          />
          <label htmlFor="image-upload">
            <Button
              variant="outlined"
              component="span"
              startIcon={<AddIcon />}
              sx={{ width: 200, color: "text.main", borderColor: "text.border" }}
            >
              تحميل الصورة
            </Button>
          </label>
          {formData.image && (
            <Avatar
              variant="square" // 👈 يجعل الصورة مربعة
              src={
                typeof formData.image === "string"
                  ? formData.image // Existing image path
                  : URL.createObjectURL(formData.image) // New file upload
              }
              sx={{
                width: 100,
                height: 100,
                mt: 2,
                border: "2px solid #ddd",
              }}
            />
          )}
          <Typography variant="caption" color="text.border" display="block" mt={1}>
            (PNG, JPG, GIF فقط)
          </Typography>
          <FormHelperText error>{errors.image}</FormHelperText>
        </Box>
        <Box mt={3}>
          <Typography variant="subtitle1" gutterBottom fontWeight="bold" color="text.main">
            ايقونة علامة التبويب
          </Typography>
          <Input
            type="file"
            inputProps={{ accept: "image/png, image/jpeg, image/gif,image/jpg" }}
            onChange={handleImageChange}
            sx={{ display: "none" }}
            id="meta-icon-upload"
            name="meta_icon"
          />
          <label htmlFor="meta-icon-upload">
            <Button
              variant="outlined"
              component="span"
              startIcon={<AddIcon />}
              sx={{ width: 200, color: "text.main", borderColor: "text.border" }}
            >
              تحميل الصورة
            </Button>
          </label>
          {formData.meta_icon && (
            <Avatar
              variant="square" // 👈 يجعل الصورة مربعة
              src={
                typeof formData.meta_icon === "string"
                  ? formData.meta_icon // Existing image path
                  : URL.createObjectURL(formData.meta_icon) // New file upload
              }
              sx={{
                width: 100,
                height: 100,
                mt: 2,
                border: "2px solid #ddd",
              }}
            />
          )}
          <Typography variant="caption" color="text.border" display="block" mt={1}>
            (PNG, JPG, GIF فقط)
          </Typography>
        </Box>
        <Box mt={3}>
          <Typography variant="subtitle1" gutterBottom fontWeight="bold" color="text.main">
            صورة غلاف الفئة
          </Typography>
          <Input
            type="file"
            inputProps={{ accept: "image/png, image/jpeg, image/gif,image/jpg" }}
            onChange={handleImageChange}
            sx={{ display: "none" }}
            id="banner-upload"
            name="banner"
          />
          <label htmlFor="banner-upload">
            <Button
              variant="outlined"
              component="span"
              startIcon={<AddIcon />}
              sx={{ width: 200, color: "text.main", borderColor: "text.border" }}
            >
              تحميل الصورة
            </Button>
          </label>
          {formData.banner && (
            <Avatar
              variant="square" // 👈 يجعل الصورة مربعة
              src={
                typeof formData.banner === "string"
                  ? formData.banner // Existing image path
                  : URL.createObjectURL(formData.banner) // New file upload
              }
              sx={{
                width: 100,
                height: 100,
                mt: 2,
                border: "2px solid #ddd",
              }}
            />
          )}
          <Typography variant="caption" color="text.border" display="block" mt={1}>
            (PNG, JPG, GIF فقط)
          </Typography>
        </Box>
      </Box>
      {/* Image Upload Section */}

      {/* Actions Section */}
      <Box mt={4} display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="body2" color="text.border">
          * الحقول المطلوبة
        </Typography>

        <Box display="flex" gap={2}>
          <Button variant="outlined" color="text.main" onClick={handleCancel} sx={{ px: 4, borderColor: "text.border" }}>
            إلغاء
          </Button>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            // disabled={Object.keys(errors).length > 0}
            sx={{ px: 4, color: "white !important", bgcolor: "primary.dark", "&:hover": { bgcolor: "primary.main" } }}
            onClick={handleSubmit}
          >
            حفظ
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default AddCategoryForm;
